// Backend converts images, spreadsheets and .msg to PDF; keep in sync with
// CONVERTIBLE_TO_PDF in statement_analyzer/services/upload_conversion.py.
export const STATEMENT_IMAGE_EXTENSIONS = [
	'jpg',
	'jpeg',
	'png',
	'heic',
	'heif',
];
export const STATEMENT_UPLOAD_EXTENSIONS = [
	'pdf',
	...STATEMENT_IMAGE_EXTENSIONS,
	'msg',
	'eml',
	'csv',
	'xlsx',
	'xls',
];
export const STATEMENT_UPLOAD_ACCEPT = STATEMENT_UPLOAD_EXTENSIONS.map(
	(ext) => `.${ext}`,
).join(',');
export const STATEMENT_UPLOAD_HINT =
	'PDF, photos (JPG, PNG, HEIC, several at once), Excel, CSV or an email (.msg, .eml), max 10MB';
export const STATEMENT_UPLOAD_ERROR =
	'Please select a PDF, photos (JPG, PNG, HEIC), an Excel or CSV file, or an email (.msg, .eml).';
export const STATEMENT_MULTI_FILE_ERROR =
	'Several files at once must all be photos of one statement (JPG, PNG or HEIC).';

const extensionOf = (file: File): string =>
	file.name.toLowerCase().split('.').pop() || '';

export const isStatementUploadFile = (file: File): boolean =>
	file.type === 'application/pdf' ||
	STATEMENT_UPLOAD_EXTENSIONS.includes(extensionOf(file));

export const isStatementImage = (file: File): boolean =>
	STATEMENT_IMAGE_EXTENSIONS.includes(extensionOf(file));

/** One file of any accepted type, or several photos that together form one statement. */
export const statementFilesError = (files: File[]): string | null => {
	if (files.length === 0) return null;
	if (files.length > 1) {
		return files.every(isStatementImage) ? null : STATEMENT_MULTI_FILE_ERROR;
	}
	return isStatementUploadFile(files[0]) ? null : STATEMENT_UPLOAD_ERROR;
};

/** Photos in page order: "Page 1", "Page 2" ... rather than the picker's order. */
export const sortStatementPhotos = (files: File[]): File[] =>
	[...files].sort((a, b) =>
		a.name.localeCompare(b.name, undefined, {
			numeric: true,
			sensitivity: 'base',
		}),
	);
